<template>
  <div class="home">
    <!-- ===================== 产品面板 01：电磁流量计（左图右文 + 水波纹） ===================== -->
    <section class="ppanel ppanel--water">
      <div class="ppanel__water" aria-hidden="true">
        <svg class="ppanel__water-svg" viewBox="0 0 1200 800" preserveAspectRatio="xMidYMid slice">
          <defs>
            <filter id="prod-water" x="-30%" y="-30%" width="160%" height="160%">
              <feTurbulence type="fractalNoise" baseFrequency="0.009 0.015" numOctaves="2" seed="6"
                stitchTiles="stitch" result="noise" />
              <feDisplacementMap in="SourceGraphic" in2="noise" scale="80" xChannelSelector="R"
                yChannelSelector="G" />
            </filter>
            <linearGradient id="prod-water-grad" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="150" y2="0"
              spreadMethod="repeat">
              <stop offset="0" stop-color="#1683e0" stop-opacity="0" />
              <stop offset="0.5" stop-color="#5daeff" stop-opacity="0.2" />
              <stop offset="1" stop-color="#1683e0" stop-opacity="0" />
            </linearGradient>
          </defs>
          <g filter="url(#prod-water)">
            <rect class="ppanel__water-fill" x="-160" y="-300" width="1520" height="1400"
              fill="url(#prod-water-grad)" />
          </g>
        </svg>
      </div>

      <div class="km-container ppanel__inner">
        <div class="ppanel__media km-reveal">
          <div class="ppanel__media-glow" aria-hidden="true"></div>
          <img :src="products[0].img" :alt="products[0].name" />
        </div>
        <div class="ppanel__body km-reveal">
          <h2 class="km-h1 ppanel__title">{{ products[0].name }}</h2>
          <p class="km-lead ppanel__desc">{{ products[0].desc }}</p>
          <div class="ppanel__actions">
            <a href="https://shunmingelectronic.com/meter/" class="km-btn km-btn-primary">了解更多</a>
          </div>
        </div>
      </div>
    </section>

    <!-- ===================== 产品面板 02：智控仪表数据云平台（文字上 + 图片下） ===================== -->
    <section class="ppanel ppanel--alt ppanel--stack">
      <div class="km-container ppanel__stack">
        <div class="ppanel__stack-body km-reveal">
          <h2 class="km-h1 ppanel__title">{{ products[1].name }}</h2>
          <p class="km-lead ppanel__desc">{{ products[1].desc }}</p>
          <div class="ppanel__actions">
            <a href="https://shunmingelectronic.com/meter/project#/project" class="km-btn km-btn-primary">了解更多</a>
          </div>
        </div>
        <div class="ppanel__stack-media km-reveal">
          <div class="ppanel__media-glow" aria-hidden="true"></div>
          <img :src="products[1].img" :alt="products[1].name" />
        </div>
      </div>
    </section>

    <!-- ===================== 产品面板 03：慧光路灯智能云平台（暂沿用左图右文，待定） ===================== -->
    <section class="ppanel">
      <div class="km-container ppanel__inner">
        <div class="ppanel__media km-reveal">
          <div class="ppanel__media-glow" aria-hidden="true"></div>
          <img :src="products[2].img" :alt="products[2].name" />
        </div>
        <div class="ppanel__body km-reveal">
          <h2 class="km-h1 ppanel__title">{{ products[2].name }}</h2>
          <p class="km-lead ppanel__desc">{{ products[2].desc }}</p>
          <div class="ppanel__actions">
            <a href="#" class="km-btn km-btn-primary"
              @click.prevent="handClick('products', { categoryId: products[2].categoryId })">了解更多</a>
          </div>
        </div>
      </div>
    </section>

    <!-- ===================== 产品面板 04：传统行业物联网改造升级（文字左 + 图片右） ===================== -->
    <section class="ppanel ppanel--alt">
      <div class="km-container ppanel__inner ppanel__inner--reverse">
        <div class="ppanel__body km-reveal">
          <h2 class="km-h1 ppanel__title">{{ products[3].name }}</h2>
          <p class="km-lead ppanel__desc">{{ products[3].desc }}</p>
          <div class="ppanel__actions">
            <a href="#" class="km-btn km-btn-primary"
              @click.prevent="handClick('products', { categoryId: products[3].categoryId })">了解更多</a>
          </div>
        </div>
        <div class="ppanel__media km-reveal">
          <div class="ppanel__media-glow" aria-hidden="true"></div>
          <img :src="products[3].img" :alt="products[3].name" />
        </div>
      </div>
    </section>

    <!-- ===================== Services ===================== -->
    <section class="km-section services">
      <div class="km-container">
        <div class="section-head km-reveal">
          <h2 class="km-h2">我们能为您提供什么</h2>
          <p class="km-lead section-head__lead">
            从城市照明到工业计量，再到传统行业数字化升级，提供端到端的物联网产品与服务。
          </p>

          <div class="metrics">
            <div class="metric">
              <span class="metric__num">10<i>+</i></span>
              <span class="metric__label">年行业研发经验</span>
            </div>
            <div class="metric">
              <span class="metric__num">4<i>+</i></span>
              <span class="metric__label">核心解决方案</span>
            </div>
            <div class="metric">
              <span class="metric__num">4G</span>
              <span class="metric__label">无缝数据传输</span>
            </div>
            <div class="metric">
              <span class="metric__num">24/7</span>
              <span class="metric__label">实时监控管理</span>
            </div>
          </div>
        </div>

        <div class="services__grid">
          <article v-for="(item, index) in services" :key="index" class="km-card service-card km-reveal"
            :style="{ transitionDelay: index * 0.08 + 's' }">
            <div class="service-card__icon">
              <img :src="item.icon" :alt="item.title" />
            </div>
            <h3 class="km-h3 service-card__title">{{ item.title }}</h3>
            <p class="service-card__desc">{{ item.desc }}</p>
          </article>
        </div>
      </div>
    </section>

    <!-- ===================== CTA ===================== -->
    <section class="km-section cta-section">
      <div class="km-container">
        <div class="cta-card km-reveal">
          <div class="cta-card__glow"></div>
          <span class="km-eyebrow">开始合作</span>
          <h2 class="km-h2 cta-card__title">准备好开启智能化升级了吗？</h2>
          <p class="km-lead cta-card__lead">
            告诉我们您的目标与挑战，我们将以清晰的思路为您提供下一步方案。
          </p>
          <div class="cta-card__actions">
            <a href="#" class="km-btn km-btn-primary" @click.prevent="handClick('contact')">立即联系</a>
            <a href="#" class="km-btn km-btn-ghost" @click.prevent="handClick('about')">了解舜铭</a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { jumpPage } from '@/utils/public';
import { getProductInfo } from '../utils/auth';
export default {
  name: 'HomeView',
  data() {
    return {
      services: [
        {
          icon: require('../assets/ludeng.png'),
          title: '智慧照明管理',
          desc: '针对城市照明路灯及园林景观灯，提供故障实时报警、远程集中控制、单灯节能管理，并支持能源消耗统计，助力智慧城市高效节能管理与运营优化。'
        },
        {
          icon: require('../assets/meter.png'),
          title: '高精度计量模块',
          desc: '提供具备超高计量精度和出色线性度表现的计量模块，确保在各种复杂工况下仍可提供稳定、可靠的计量结果，满足工业级别要求。'
        },
        {
          icon: require('../assets/yunpingtai.png'),
          title: '物联网整体方案',
          desc: '凭借十余年物联网整体解决方案的研发经验，推动各行业数字化转型与智能化升级，帮助传统行业提升效率和竞争力。'
        }
      ],
      products: [
        {
          name: '电磁流量计转换器',
          categoryId: 4,
          img: 'https://qiniu.shunmingelectronic.com/guanwang/product/%E5%B0%8F%E8%93%9D%E6%AD%A3%EF%BC%88%E5%8E%8B%E7%BC%A9%EF%BC%89.png',
          desc: '高精度电磁流量计转换器，稳定可靠，适用于多种复杂工况下的流量测量与监控。'
        },
        {
          name: '智控仪表数据云平台',
          categoryId: 2,
          img: 'https://qiniu.shunmingelectronic.com/guanwang/product/denglulong.png',
          desc: '集中管理仪表数据，实时监控与可视化分析，让数据驱动决策更高效。'
        },
        {
          name: '路灯智能云平台',
          categoryId: 1,
          img: 'https://qiniu.shunmingelectronic.com/guanwang/product/lighttoumingbeijing.png',
          desc: '面向城市照明的智能云平台，远程控制、节能管理与故障报警一体化。'
        },
        {
          name: '传统行业物联网改造升级',
          categoryId: 3,
          img: 'https://qiniu.shunmingelectronic.com/guanwang/product/nongyegaizao.png',
          desc: '将数字化与信息化理念融入传统行业，实现优势互补与效率跃升。'
        }
      ],
      categoryList: []
    }
  },
  methods: {
    handClick(val, query) {
      jumpPage(val, query);
    },
    setupReveal() {
      const els = this.$el.querySelectorAll('.km-reveal');
      if (!('IntersectionObserver' in window)) {
        els.forEach(el => el.classList.add('is-visible'));
        return;
      }
      const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      els.forEach(el => io.observe(el));
      this._io = io;
    }
  },
  mounted() {
    this.categoryList = getProductInfo();
    // 首次进入网站时有进场页，等其消失后再触发首屏动态加载动画；
    // 后续页面间导航没有进场页，则立即触发。
    if (document.querySelector('.intro-screen')) {
      this._revealTimer = setTimeout(() => {
        this.$nextTick(() => {
          this.setupReveal();
        });
      }, 3300);
    } else {
      this.$nextTick(() => {
        this.setupReveal();
      });
    }
  },
  beforeUnmount() {
    if (this._io) this._io.disconnect();
    if (this._revealTimer) clearTimeout(this._revealTimer);
  }
}
</script>

<style scoped>
.home {
  background: var(--bg);
  overflow: hidden;
}

/* ===================== 产品全屏面板 ===================== */
.ppanel {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  padding: 120px 0;
  overflow: hidden;
  background: var(--bg);
}

.ppanel--alt {
  background: #f5f7fb;
}

.ppanel__inner {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: 1.05fr 1fr;
  gap: 200px;
  align-items: center;
  width: 100%;
}

/* --- 图片 --- */
.ppanel__media {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 40vh;
}

.ppanel__media-glow {
  position: absolute;
  inset: 8% 6%;
  background: radial-gradient(circle at 50% 50%, rgba(93, 174, 255, 0.22), transparent 68%);
  filter: blur(26px);
  z-index: 0;
}

.ppanel__media img {
  position: relative;
  z-index: 1;
  max-width: 100%;
  max-height: 62vh;
  object-fit: contain;
  filter: drop-shadow(0 34px 60px rgba(15, 18, 24, 0.16));
}

/* --- 文字 --- */
.ppanel__body {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  gap: 22px;
}

.ppanel__title {
  margin: 0;
}

.ppanel__desc {
  max-width: 520px;
  margin: 0;
}

.ppanel__actions {
  margin-top: 8px;
}

/* --- 动态加载：图片从左、文字从右 --- */
.ppanel .km-reveal {
  transition: opacity 0.9s ease, transform 0.9s cubic-bezier(0.2, 0.7, 0.2, 1);
}

.ppanel__media.km-reveal {
  transform: translateX(-56px);
}

.ppanel__media.km-reveal.is-visible {
  transform: none;
}

.ppanel__body.km-reveal {
  transform: translateX(56px);
  transition-delay: 0.12s;
}

.ppanel__body.km-reveal.is-visible {
  transform: none;
}

/* --- 布局：文字左 + 图片右（反向，动态方向随之调换） --- */
.ppanel__inner--reverse .ppanel__media.km-reveal {
  transform: translateX(56px);
}

.ppanel__inner--reverse .ppanel__body.km-reveal {
  transform: translateX(-56px);
}

.ppanel__inner--reverse .ppanel__media.km-reveal.is-visible,
.ppanel__inner--reverse .ppanel__body.km-reveal.is-visible {
  transform: none;
}

/* --- 布局：文字上 + 图片下（智控仪表数据云平台） --- */
.ppanel__stack {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 48px;
  width: 100%;
}

.ppanel__stack-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 20px;
  max-width: 760px;
}

.ppanel__stack-media {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.ppanel__stack-media img {
  position: relative;
  z-index: 1;
  max-width: min(1000px, 100%);
  max-height: 56vh;
  object-fit: contain;
  border-radius: var(--radius-lg);
  filter: drop-shadow(0 36px 70px rgba(15, 18, 24, 0.18));
}

.ppanel__stack-media.km-reveal {
  transition-delay: 0.12s;
}

/* --- 水波纹背景（电磁流量计面板） --- */
.ppanel__water {
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  overflow: hidden;
  -webkit-mask-image: radial-gradient(120% 120% at 30% 50%, #000 35%, transparent 82%);
  mask-image: radial-gradient(120% 120% at 30% 50%, #000 35%, transparent 82%);
}

.ppanel__water-svg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: block;
}

.ppanel__water-fill {
  animation: water-flow 3.5s linear infinite;
}

@keyframes water-flow {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(150px);
  }
}

@media (prefers-reduced-motion: reduce) {
  .ppanel__water-fill {
    animation: none !important;
  }

  .ppanel .km-reveal {
    transform: none !important;
  }
}

/* ===================== 指标数据 ===================== */
.metrics {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  width: 100%;
  max-width: 880px;
  margin-top: 24px;
  padding-top: 44px;
  border-top: 1px solid var(--border);
}

.metric {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.metric__num {
  font-family: var(--font-display);
  font-size: clamp(30px, 3.4vw, 46px);
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--text);
}

.metric__num i {
  color: var(--accent);
  font-style: normal;
}

.metric__label {
  font-size: 14px;
  color: var(--text-soft);
}

/* ===================== Section head ===================== */
.section-head {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 18px;
  margin-bottom: 64px;
}

.section-head__lead {
  max-width: 600px;
}

/* ===================== Services ===================== */
.services {
  position: relative;
  overflow: hidden;
  background:
    radial-gradient(48% 34% at 10% 4%, rgba(93, 174, 255, 0.16), transparent 62%),
    radial-gradient(44% 32% at 92% 20%, rgba(22, 131, 224, 0.12), transparent 62%),
    radial-gradient(46% 32% at 6% 62%, rgba(22, 131, 224, 0.10), transparent 62%),
    radial-gradient(50% 34% at 96% 82%, rgba(93, 174, 255, 0.13), transparent 62%);
}

/* 点阵装饰：覆盖整段高度，仅顶/底边缘柔和淡出 */
.services::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: radial-gradient(rgba(15, 18, 24, 0.09) 1px, transparent 1px);
  background-size: 22px 22px;
  -webkit-mask-image: linear-gradient(180deg, transparent 0%, #000 10%, #000 90%, transparent 100%);
  mask-image: linear-gradient(180deg, transparent 0%, #000 10%, #000 90%, transparent 100%);
  pointer-events: none;
  z-index: 0;
}

.services > .km-container {
  position: relative;
  z-index: 1;
}

.services__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.service-card {
  padding: 40px 34px;
  text-align: left;
  display: flex;
  flex-direction: column;
}

.service-card__icon {
  width: 88px;
  height: 88px;
  border-radius: 20px;
  background: var(--accent-soft);
  border: 1px solid var(--border);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 28px;
}

.service-card__icon img {
  width: 56px;
  height: 56px;
  object-fit: contain;
}

.service-card__title {
  margin-bottom: 14px;
}

.service-card__desc {
  color: var(--text-soft);
  font-size: 15px;
  line-height: 1.75;
  margin: 0;
}

/* ===================== CTA ===================== */
.cta-section {
  padding-top: 0;
  padding-bottom: 140px;
}

.cta-card {
  position: relative;
  overflow: hidden;
  border-radius: var(--radius-lg);
  border: 1px solid var(--border);
  background: linear-gradient(180deg, #f7f8fa, #eef1f6);
  padding: 80px 40px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.cta-card__glow {
  position: absolute;
  bottom: -200px;
  left: 50%;
  transform: translateX(-50%);
  width: 700px;
  height: 500px;
  background: radial-gradient(circle at 50% 50%, rgba(93, 174, 255, 0.25), rgba(93, 174, 255, 0) 65%);
  pointer-events: none;
}

.cta-card> :not(.cta-card__glow) {
  position: relative;
  z-index: 1;
}

/* “开始合作”标签放大 */
.cta-card .km-eyebrow {
  font-size: 15px;
  letter-spacing: 0.2em;
  padding: 10px 22px;
}

.cta-card .km-eyebrow::before {
  width: 8px;
  height: 8px;
}

.cta-card__title {
  max-width: 640px;
}

.cta-card__lead {
  max-width: 520px;
}

.cta-card__actions {
  display: flex;
  gap: 14px;
  margin-top: 16px;
  flex-wrap: wrap;
  justify-content: center;
}

/* ===================== Responsive ===================== */
@media (max-width: 980px) {
  .services__grid {
    grid-template-columns: 1fr;
  }

  .ppanel {
    padding: 100px 0;
  }

  .ppanel__inner {
    grid-template-columns: 1fr;
    gap: 40px;
    text-align: center;
  }

  .ppanel__body {
    align-items: center;
    text-align: center;
  }

  .ppanel__desc {
    margin-left: auto;
    margin-right: auto;
  }

  /* 窄屏统一改为纵向淡入，避免横向位移过大 */
  .ppanel__media.km-reveal,
  .ppanel__body.km-reveal {
    transform: translateY(36px);
  }

  .ppanel__media.km-reveal.is-visible,
  .ppanel__body.km-reveal.is-visible {
    transform: none;
  }

  .metrics {
    grid-template-columns: repeat(2, 1fr);
    gap: 32px 24px;
  }
}

@media (max-width: 600px) {
  .cta-card {
    padding: 56px 24px;
  }
}
</style>
